<template>
  <div class="content">
    <div>
      <div class="logo" style="width: 100%;margin-bottom: 20px;margin-left: 10px">
        <img src="../static/img/login/logo.png" alt="">
      </div>
      <div class="login">
        <el-row>
          <el-col :span="6">
            <img src="../static/img/login/bg.png" alt="">
          </el-col>
          <el-col :span="18">
            <el-form ref="form" label-width="auto" style="width: 350px;margin: 0 auto">
              <el-form-item>
                <h1 style="text-align: center;font-weight: 500;">登录</h1>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-input style="border-radius: 20px" v-model="loginData.mobile" placeholder="请输入手机号"></el-input>
                <div style="margin-left: 20px;height:40px;color: red">{{loginTip}}</div>
              </el-form-item>
              <el-form-item style="display: inline-block">
                <el-button :disabled="loginBtn" @click="getCode(loginData.mobile,loginSend,'login')"
                           style="width: 180px;color: white" :style="pt"
                           round>
                  {{loginTime}}
                </el-button>
                <el-input style="width: 150px;margin-left: 20px" v-model="loginData.verificationCode"
                          placeholder="请输入验证码"></el-input>
                <el-checkbox v-model="checked">记住我</el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-button @click="isBind(loginData,login,'login')" round
                           style="width: 100%;background-color: #43bae9;color: white">登&nbsp录
                </el-button>
              </el-form-item>
              <el-form-item style="margin: 0;text-align: center">
                <el-button @click="changePhone()" class="btnImg"
                           style="width: 202px;height: 38px;border-radius: 20px;margin-top: 10px"></el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog :fullscreen="true" :visible.sync="outerVisible" v-if="outerVisible">
      <el-dialog
        :visible.sync="innerVisible"
        v-if="innerVisible"
        :fullscreen="true"
        append-to-body>
        <div class="content">
          <div>
            <div class="logo" style="width: 100%;margin-bottom: 20px;margin-left: 10px">
              <img src="../static/img/login/logo.png" alt="">
            </div>
            <div class="login" style="width: 450px;height: 320px">
              <el-row>
                <el-form ref="form" label-width="auto" style="width: 350px;margin: 0 auto">
                  <el-form-item>
                    <h1 style="text-align: center;font-weight: 500;margin-top: 10px">
                      <i @click="goBack(2)" class="el-icon-arrow-left" style="position: relative;left: -95px"></i>
                      绑定新的手机号</h1>
                  </el-form-item>
                  <el-form-item style="margin-bottom: 0">
                    <el-input style="border-radius: 20px" v-model="bind.mobile" placeholder="请输入新的手机号"></el-input>
                    <div style="margin-left: 20px;height:40px;color: red">{{bindTip}}</div>
                  </el-form-item>
                  <el-form-item style="display: inline-block">
                    <el-button :disabled="bindBtn" @click="getCode(bind.mobile,bindSend,'isBind')"
                               style="width: 180px;color: white" :style="pt"
                               round>
                      {{bindTime}}
                    </el-button>
                    <el-input style="width: 150px;margin-left: 20px" v-model="bind.verificationCode"
                              placeholder="请输入验证码"></el-input>
                  </el-form-item>
                  <el-form-item style="margin-top: 40px">
                    <el-button @click="isBind(bind,end,'isBind')" round
                               style="width: 100%;background-color: #43bae9;color: white">确定
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-row>
            </div>
          </div>
        </div>
      </el-dialog>
      <div class="content">
        <div>
          <div class="logo" style="width: 100%;margin-bottom: 20px;margin-left: 10px">
            <img src="../static/img/login/logo.png" alt="">
          </div>
          <div class="login" style="width: 450px;height: 320px">
            <el-row>
              <el-form ref="form" label-width="auto" style="width: 350px;margin: 0 auto">
                <el-form-item>
                  <h1 style="text-align: center;font-weight: 500;margin-top: 10px">
                    <i @click="goBack(1)" class="el-icon-arrow-left" style="position: relative;left: -80px"></i>
                    解除原绑定手机号</h1>
                </el-form-item>
                <el-form-item style="margin-bottom: 0">
                  <el-input style="border-radius: 20px" v-model="unBind.mobile" placeholder="请输入已绑定的手机号"></el-input>
                  <div style="margin-left: 20px;height:40px;color: red">{{unBindTip}}</div>
                </el-form-item>
                <el-form-item style="display: inline-block">
                  <el-button :disabled="unBtn" @click="getCode(unBind.mobile,unSend,'unBind')"
                             style="width: 180px;color: white" :style="pt"
                             round>
                    {{unTime}}
                  </el-button>
                  <el-input style="width: 150px;margin-left: 20px" v-model="unBind.verificationCode"
                            placeholder="请输入验证码"></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 40px">
                  <el-button @click="isBind(unBind,next,'unBind')" round
                             style="width: 100%;background-color: #43bae9;color: white">下一步
                  </el-button>
                </el-form-item>
              </el-form>
            </el-row>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'home',
    components: {},
    data: function () {
      return {
        pt: 'backgroundColor: #55c1e9',
        loginTime: '获取验证码',
        loginBtn: false,
        bindTime: '获取验证码',
        bindBtn: false,
        unTime: '获取验证码',
        unBtn: false,
        loginData: {
          msgId: '',
          mobile: '',
          verificationCode: ''
        },
        loginTip: '',
        unBind: {
          msgId: '',
          mobile: '',
          verificationCode: ''
        },
        unBindTip: '',
        bind: {
          msgId: '',
          mobile: '',
          oldMobile: '',
          verificationCode: ''
        },
        bindTip: '',
        checked: false,
        outerVisible: false,
        innerVisible: false
      }
    },
    mounted() {
      console.log(this.user);
      if(localStorage.getItem('myChecked')){
      this.loginData.mobile = localStorage.getItem('myChecked')
      this.checked = true
      }
                 
    },
    computed: {
      ...mapGetters([
        'user',
      ])
    },
    methods: {
      ...mapActions([
        'saveUser'
      ]),
      getCode(mobile, fn, step) {
        let type;
        if (step === 'isBind') {
          type = 4
          if (this.bind.mobile === '') {
            this.$message.error('请输入手机号！')
            return
          }
        }
        if (step === 'unBind') {
          type = 3
          if (this.unBind.mobile === '') {
            this.$message.error('请输入手机号！')
            return
          }
        }
        if (step === 'login') {
          type = 2
          if (this.loginData.mobile === '') {
            this.$message.error('请输入手机号！')
            return
          }
        }
        this.$api.user.send({mobile: mobile, type: type}).then(res => {
          if (res.data.code === 200) {
            if (res.data.message === '' || res.data.message === null) {
              this.$message.success('发送成功')
              fn(res.data.resultData)
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      },
      loginSend(msgId) {
        this.pt = 'backgroundColor: #BBBBBB'
        this.loginTime = 60
        this.loginBtn = true
        this.loginData.msgId = msgId
        let time = setInterval(() => {
          if (this.loginTime > 0 && this.loginBtn) {
            this.loginTime--
          } else {
            this.loginTime = '获取验证码'
            this.loginBtn = false
            this.pt = 'backgroundColor: #55c1e9'
            clearInterval(time)
          }
        }, 1000)
      },
      bindSend(msgId) {
        this.pt = 'backgroundColor: #BBBBBB'
        this.bindTime = 60
        this.bindBtn = true
        this.bind.msgId = msgId
        let time = setInterval(() => {
          if (this.bindTime > 0 && this.bindBtn) {
            this.bindTime--
          } else {
            this.bindTime = '获取验证码'
            this.bindBtn = false
            this.pt = 'backgroundColor: #55c1e9'
            clearInterval(time)
          }
        }, 1000)
      },
      unSend(msgId) {
        this.pt = 'backgroundColor: #BBBBBB'
        this.unTime = 60
        this.unBtn = true
        this.unBind.msgId = msgId
        let time = setInterval(() => {
          if (this.unTime > 0 && this.unBtn) {
            this.unTime--
          } else {
            this.unTime = '获取验证码'
            this.unBtn = false
            this.pt = 'backgroundColor: #55c1e9'
            clearInterval(time)
          }
        }, 1000)
      },
      changePhone() {
        this.outerVisible = true
        this.btnType()
      },
      goBack(val) {
        if (val === 1) {
          this.outerVisible = false
        } else {
          this.innerVisible = false
        }
        this.btnType()
      },
      btnType() {
        this.loginTime = '获取验证码'
        this.loginData.msgId = ''
        this.loginBtn = false
        this.bindTime = '获取验证码'
        this.bind.msgId = ''
        this.bindBtn = false
        this.unTime = '获取验证码'
        this.unBind.msgId = ''
        this.unBtn = false
        this.pt = 'backgroundColor: #55c1e9'
      },
      end(isbind) {
        if (isbind) {
          this.bindTip = '该手机号已经绑定'
        } else {
          this.$api.user.bind(this.bind).then(res => {
            if (res.data.code === 200) {
              if (res.data.message === '' || res.data.message === null) {
                this.innerVisible = false
                this.outerVisible = false
                this.$message.success('绑定成功！')
              } else {
                this.$message.error(res.data.message)
              }
            } else {
              this.$message.error('绑定失败！')
            }
          })
        }
      },

      next(isbind) {
        if (isbind) {
          this.$api.user.unBind(this.unBind).then(res => {
            if (res.data.code === 200) {
              if (res.data.message === '' || res.data.message === null) {
                this.bind.oldMobile = this.unBind.mobile
                console.log(this.bind.oldMobile);
                this.innerVisible = true
                this.$message.success('解除成功！')
                this.btnType()
              } else {
                this.$message.error(res.data.message)
              }
            } else {
              this.$message.error('解除失败！')
            }
          })
        } else {
          this.unBindTip = '该手机号尚未绑定'
        }
      },
      isBind(data, Fn, step) {

        this.loginTip = ''
        this.unBindTip = ''
        this.bindTip = ''
        if (step === 'isBind') {
          if (this.bind.mobile === '') {
            this.$message.error('请输入手机号！')
            return
          }
          if (this.bind.verificationCode === '') {
            this.$message.error('请输入验证码！')
            return
          }
        }
        if (step === 'unBind') {
          if (this.unBind.mobile === '') {
            this.$message.error('请输入手机号！')
            return
          }
          if (this.unBind.verificationCode === '') {
            this.$message.error('请输入验证码！')
            return
          }
        }
        if (step === 'login') {
          if (this.loginData.mobile === '') {
            this.$message.error('请输入手机号！')
            return
          }
          if (this.loginData.verificationCode === '') {
            this.$message.error('请输入验证码！')
            return
          }
        }
        this.$api.user.isBind(data).then(res => {
          if (res.data.code === 200) {
            Fn(res.data.resultData)
          }
        })
      },
      login(isbind) {

        // this.saveUser({a: 1})
        // this.$router.push({path: '/tv'})
        // this.$message.success('登录成功！')
        if (isbind) {
          this.$api.user.login(this.loginData).then(res => {
            if (res.data.code === 200) {
              if (res.data.message === '' || res.data.message === null) {
                let resData = res.data.resultData
                let checked = this.checked
                let userData = {...resData, checked}
                this.saveUser(userData)
                this.$router.push({path: '/tv'})
                this.$message.success('登录成功！')
                // 登录成功保存手机号
                if(this.checked){
                  localStorage.setItem('myChecked',this.loginData.mobile)
                }else{
                  localStorage.removeItem('myChecked')

                }
              } else {
                this.$message.error(res.data.message)
              }
            } else {
              this.$message.error('登录失败！')
            }
          })
        } else {
          this.loginTip = '该手机号尚未绑定'
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .login {
    width: 600px;
    height: 360px;
    border-radius: 18px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  /deep/ .el-input__inner, .el-checkbox__inner {
    border-radius: 30px;
  }

  .btnImg {
    background-image: url('../static/img/login/btn.png')
  }

  /deep/ .el-dialog__body {
    padding: 0;
    height: 100%;
  }

  /deep/ .el-dialog__header {
    padding: 0;
  }
</style>
